import React from 'react';
import ReactCodeInput from 'react-code-input';

import { inputStyles, inputStyleInvalid } from 'components/CodeInput/styles';

type InputCodeType = {
  name: string;
  fields: number;
  handleChange: (value: string) => void;
  value: string;
  isValid: boolean;
  width?: string;
  height?: string;
};

const InputCode = ({
  name,
  fields,
  handleChange,
  value,
  isValid,
  width,
  height,
}: InputCodeType) => (
  <ReactCodeInput
    name={name}
    fields={fields}
    onChange={handleChange}
    value={value}
    inputStyle={{ ...inputStyles, width, height }}
    inputStyleInvalid={{ ...inputStyleInvalid, width, height }}
    isValid={isValid}
    type="text"
    inputMode="latin"
    pattern="[0-9]"
    autoFocus={true}
  />
);

export default InputCode;
